import { IconProps } from "@tabler/icons-react"
import { classNames } from "../../../utils/classNames"

export type ButtonColorVariant = "dark" | "yellow" | "tertiary"
export type ButtonSizeVariant = "large" | "medium" | "small" | "xsmall"
export type ButtonAlignment = "left" | "center"

export interface ButtonBaseProps {
  IconLeft?: React.ComponentType<IconProps>
  IconRight?: React.ComponentType<IconProps>
  title?: string
  isDisabled?: boolean
  variantSize?: ButtonSizeVariant
  variantColor?: ButtonColorVariant
  isFullWidth?: boolean
  className?: string
}

export const ButtonBase: React.FC<ButtonBaseProps> = ({
  IconLeft,
  IconRight,
  title,
  isDisabled = false,
  variantSize = "large",
  variantColor = "dark",
  isFullWidth = false,
  className,
}) => {
  return (
    <div
      className={classNames(
        isFullWidth ? "flex w-full" : "inline-flex",
        "truncate",
        "items-center gap-2",
        "rounded-lg border border-transparent",
        "hover:cursor-pointer",
        isDisabled && "pointer-events-none",
        "justify-center",
        variantSize === "large" && "px-[18px] py-[14px]",
        variantSize === "medium" && "px-4 py-3",
        variantSize === "small" && "px-3 py-2",
        variantSize === "xsmall" && "px-3 py-2",
        variantColor === "dark" && "border-grey4 text-white hover:border-white",
        variantColor === "dark" && isDisabled && "text-grey4",
        variantColor === "yellow" && "bg-yellow1 text-black hover:bg-yellow3",
        variantColor === "yellow" && isDisabled && "bg-yellow5",
        variantColor === "tertiary" && "text-white",
        variantColor === "tertiary" && isDisabled && "text-grey4",
        !title && "px-2 py-2",
        className,
      )}
    >
      {IconLeft && (
        <IconLeft
          size={variantSize === "small" || variantSize === "xsmall" ? 16 : 24}
        />
      )}
      {title && (
        <p
          className={classNames(
            "font-semibold",
            variantSize === "large" && "text-lg",
            variantSize === "small" && "text-sm",
            variantSize === "xsmall" && "text-xs",
          )}
        >
          {title}
        </p>
      )}
      {IconRight && (
        <IconRight
          size={variantSize === "small" || variantSize === "xsmall" ? 16 : 24}
        />
      )}
    </div>
  )
}
